import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import DefaultLayout from "/home/runner/work/wh-support-docs/wh-support-docs/node_modules/gatsby-theme-carbon/src/templates/Default.js";
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const PageDescription = makeShortcode("PageDescription");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <PageDescription mdxType="PageDescription">
      <p>{`Here are some videos to help you to get started.`}</p>
      <p>{`Please note that these videos were recorded before our brand changed from Watson Care Manager to Merative Integrated Care. You will see Watson Care Manager referenced throughout the videos.`}</p>
    </PageDescription>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://mediacenter.ibm.com/media/Using%20the%20new%20care%20plan%20in%20Watson%20Care%20Manager%20to%20customize%20the%20most%20appropriate%20care%20plan%20for%20a%20client./1_socf5boe"
        }}>{`Using the new care plan in Watson Care Manager to customize the most appropriate care plan for a client`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://mediacenter.ibm.com/media/Signing+in+to+IBM+Watson+Care+Manager+and+managing+your+Watson+Care+Manager+account/1_iorm7m0t"
        }}>{`Signing in to Watson Care Manager and managing your Watson Care Manager account`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://mediacenter.ibm.com/media/Signing+in+to+IBM+Watson+Care+Manager+where+your+organization+enabled+multi-factor+authentication+and+managing+your+Watson+Care+Manager+account/1_h4mz2z6l"
        }}>{`Signing in to Watson Care Manager where your organization enabled multi-factor authentication and managing your Watson Care Manager account`}</a></li>
    </ul>
    <h2>{`Show and tell videos`}</h2>
    <p>{`Show and tell videos highlight the latest enhancements in Merative Integrated Care.`}</p>
    <p>{`For the show and tell videos that were recorded before 1 October 2022, see the `}<a parentName="p" {...{
        "href": "https://www.ibm.com/support/pages/node/6343209"
      }}>{`IBM Watson Care Manager show and tell videos`}</a>{` on the IBM Support Pages.`}</p>
    <p>{`Show and tell videos that were recorded after 1 October 2022 are published on this page under the following section.`}</p>
    <h3>{`Show and tell videos for releases from 1 October 2022`}</h3>
    <ul>
      <li parentName="ul">
        <p parentName="li"><a parentName="p" {...{
            "href": "/wh-support-docs/videos/show-and-tell-March2023-captions.mp4"
          }}>{`Show and tell March 2023 with captions`}</a></p>
      </li>
      <li parentName="ul">
        <p parentName="li"><a parentName="p" {...{
            "href": "/wh-support-docs/videos/show-and-tell-March2023-no-captions.mp4"
          }}>{`Show and tell March 2023 without captions`}</a></p>
      </li>
      <li parentName="ul">
        <p parentName="li"><a parentName="p" {...{
            "href": "/wh-support-docs/videos/show-and-tell-Jan2023-captions.mp4"
          }}>{`Show and tell January 2023 with captions`}</a></p>
      </li>
      <li parentName="ul">
        <p parentName="li"><a parentName="p" {...{
            "href": "/wh-support-docs/videos/show-and-tell-Jan2023-no-captions.mp4"
          }}>{`Show and tell January 2023 without captions`}</a></p>
      </li>
      <li parentName="ul">
        <p parentName="li"><a parentName="p" {...{
            "href": "/wh-support-docs/videos/show-and-tell-Nov22.mp4"
          }}>{`Show and tell November 2022 with captions`}</a></p>
      </li>
      <li parentName="ul">
        <p parentName="li"><a parentName="p" {...{
            "href": "/wh-support-docs/videos/Show-and-Tell_Nov_22_no_captions.mp4"
          }}>{`Show and tell November 2022 without captions`}</a></p>
      </li>
    </ul>
    <h2>{`Configuring an assessment videos`}</h2>
    <p>{`These seven short videos guide you through the entire process of how to configure an assessment in Merative Integrated Care.`}</p>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://mediacenter.ibm.com/media/t/1_euqnj9lf"
        }}>{`Configuring an assessment part 1 of 7: Creating the assessment goals and actions`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://mediacenter.ibm.com/media/t/1_p4u73ud1"
        }}>{`Configuring an assessment part 2 of 7: Configuring the assessment answers`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://mediacenter.ibm.com/media/t/1_nqpbvdd9"
        }}>{`Configuring an assessment part 3 of 7: Configuring the assessment questions`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://mediacenter.ibm.com/media/t/1_udjwb468"
        }}>{`Configuring an assessment part 4 of 7: Configuring the conditional questions`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://mediacenter.ibm.com/media/t/1_1u6z7k3n"
        }}>{`Configuring an assessment part 5 of 7: Configuring the assessment measures and classifications`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://mediacenter.ibm.com/media/t/1_od1sw25k"
        }}>{`Configuring an assessment part 6 of 7: Configuring the assessment recommendations`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://mediacenter.ibm.com/media/t/1_2v22t2zn"
        }}>{`Configuring an assessment part 7 of 7: Validating, activating, and verifying the assessment`}</a></li>
    </ul>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      